import { BaseTranslator } from '../base';

import vi from './languages/vi.json';
import en from './languages/en.json';
import zh from './languages/zh.json';
import id from './languages/id.json';

export type TMmoLanguageTokens = keyof typeof vi;

export class Mmo extends BaseTranslator {
  private static _instance: Mmo;

  public static instance() {
    if (!Mmo._instance) {
      Mmo._instance = new Mmo();
    }

    return Mmo._instance;
  }

  protected override builder(): void {
    this.setResources([
      {
        language: 'vi',
        resource: vi,
      },
      {
        language: 'en',
        resource: en,
      },
      {
        language: 'zh',
        resource: zh,
      },
      {
        language: 'id',
        resource: id,
      },
    ]);
  }

  public getCategoryToken(countryId?: string, categoryId?: string) {
    return `lottery.category.${countryId?.toUpperCase()}.${categoryId?.toUpperCase()}`;
  }

  public getSchedulerToken(schedulerId?: string) {
    return `lottery.scheduler.${schedulerId}`;
  }

  public getPrizePositionToken(prizePosition?: number) {
    return `lottery.prize.position.${prizePosition}`;
  }
}
